import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getDate } from 'date-fns';
import { AlertasService } from 'src/app/services/alertas.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-alerta',
  templateUrl: './alerta.component.html',
  styleUrls: ['./alerta.component.css'],
})
export class AlertaComponent implements OnInit {
  alerta = {
    avatarColegio: '',
    estado: '',
    fechaAlerta: '',
    idAlerta: '',
    idColegio: '',
    idSupervisor: '',
    idUsuario: '',
    mensaje: '',
    mostrarSupervisor: true,
    avatarAlumno: '',
    reportada: true,
    nombre:''
  };
  str: any[];
  idOriginal: any = '';
  nombreAlumno: any;
  tacos: Array<any>;
  iguales: any;
  constructor(
    private _alertService: AlertasService,
    private route: ActivatedRoute,
    private router: Router,
    private _userService: UserService
  ) {}
  ngOnInit(): void {
    this.alerta.idAlerta = this.route.snapshot.params['idAlerta'];
    this._alertService.getAlerts().subscribe((alertas) => {
      alertas.forEach((alertaComp) => {
        let alertaVar = alertaComp.payload.doc.data();
        if (alertaVar['idAlerta'] == this.alerta.idAlerta) {
          if (alertaVar['avatarColegio']) {
            this.alerta.avatarColegio = alertaVar['avatarColegio'];
          } else {
            this.alerta.avatarColegio = 'assets/img/defaultavatar.jpg';
          }
          this.alerta.estado = alertaVar['estado'];
          this.alerta.fechaAlerta = alertaVar['fechaAlerta'].toDate();
          this.alerta.idColegio = alertaVar['idColegio'];
          this.alerta.idSupervisor = alertaVar['idSupervisor'];
          this.alerta.idUsuario = alertaVar['idUsuario'];
          this.alerta.mensaje = alertaVar['mensaje'];
          this.alerta.mostrarSupervisor = alertaVar['mostrarSupervisor'];
          this.alerta.reportada = alertaVar['reportada'];
          this.alerta.avatarAlumno = alertaVar['avatarAlumno'];
          this.alerta.nombre = alertaVar['nombre'];
          this.idOriginal = alertaComp.payload.doc.id;
          this.nombreAlumno = this.alerta.nombre;
          // this.getNameOfUsers();

          }
         
      });
    });
  }
  getNameOfUsers() {
    this._userService.getUsers().subscribe((users) => {
      users.forEach((user) => {
        const User = user.payload.doc.data();
        if (User['uid'] == this.alerta.idUsuario) {
          this.nombreAlumno = User['nombres'];
        }
      });
    });
  }

  deleteAlert() {
    this._alertService.deleteAlert(this.idOriginal);
    this.router.navigate(['/admin/alertas']);
  }
  reportAlert() {
    //TODO Recoger esta alerta y updatear

    this.alerta.reportada = true;
    this.alerta.mostrarSupervisor = true;
    this._alertService.editAlerta(this.idOriginal, this.alerta);
    this.router.navigate(['admin/alertas/alerta/' + this.alerta.idAlerta]);
  }

  cancelAlert() {
    //TODO Recoger esta alerta y updatear
    this.alerta.reportada = false;
    this._alertService.editAlerta(this.idOriginal, this.alerta);
    this.router.navigate(['admin/alertas/alerta/' + this.alerta.idAlerta]);
  }
  ngOnDestroy() {}
}
